export enum PosthogFeatureFlag {
  OO_CASE_NEW_SECTIONS = 'oo_case_new_sections',
  OO_CASE_SOLICITORS = 'oo_case_solicitors',
  OO_CASE_DIP_ACCEPTED_EDIT = 'oo_case_dip_accepted_edit',
  OO_CASE_CREATE_FLOW = 'oo_case_create_flow',
  OO_CASE_SUBMISSION = 'oo_case_submission',
  OO_CASE_DEPOSIT_SOURCES = 'oo_case_deposit_sources',
  HPP_PERMISSIONED_PAGES = 'hpp_permissioned_pages',
  USE_TYPESENSE_CASE_SEARCH = 'use-typesense-case-search-fe',
}
